import { Avatar, Card, CardContent, CardHeader, Divider, Grid, IconButton, List, ListItem, ListItemIcon, ListItemText, Tooltip, Typography, } from "@material-ui/core";
import { Link } from "@material-ui/icons";
import React from "react";
import { useFieldLookup } from "../../../hooks/useFieldLookup";
import { exceptionalCircumstanceService, stagesService } from "../../../services";
import { userRendererStyles } from "./useRendererStyles";
export const ListTile = ({ tile, navigate }) => {
    const classes = userRendererStyles();
    return (React.createElement(Grid, { item: true, xs: 12, md: 6 },
        React.createElement(Card, { className: classes.root },
            React.createElement(CardHeader, { action: React.createElement(Tooltip, { title: `View list of ${tile.title}` },
                    React.createElement(IconButton, { onClick: () => navigate && navigate(tile.filterUrl) },
                        React.createElement(Link, null))), title: React.createElement(Typography, { variant: "body1", className: classes.cardHeading }, tile.title), className: classes.header }),
            React.createElement(Divider, null),
            React.createElement(CardContent, null,
                React.createElement(Grid, { container: true },
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(List, null, tile.parsedData.map((data, index) => {
                            return (React.createElement(ListItem, { key: index },
                                React.createElement(ListItemIcon, null,
                                    React.createElement(Tooltip, { title: "View list" },
                                        React.createElement(IconButton, { onClick: () => navigate && navigate(`${tile.filterUrl}&DashboardParam=${data.key}`) },
                                            React.createElement(Avatar, { className: classes.countAvatar }, data.value)))),
                                React.createElement(ListItemText, { primary: getListText(tile.title, data.key), className: classes.listText })));
                        }))))))));
};
const getListText = (tileTitle, dataTitle) => {
    switch (tileTitle) {
        case "Top 10 themes":
            return React.createElement(ThemesListTileText, { title: dataTitle });
        case "Cases by stage":
        case "Paused SLA cases by stage":
            return React.createElement(StagesListTileText, { title: dataTitle });
        default:
            return React.createElement(Typography, { component: "span" }, dataTitle);
    }
};
const ThemesListTileText = ({ title }) => {
    const tileLookup = useFieldLookup(exceptionalCircumstanceService, title);
    return React.createElement(Typography, { component: "span" }, tileLookup);
};
const StagesListTileText = ({ title }) => {
    const tileLookup = useFieldLookup(stagesService, title);
    return React.createElement(Typography, { component: "span" }, tileLookup);
};
